import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import {BaseChartDirective} from "ng2-charts/index";
import {TranslateService} from "ng2-translate/index";

import {WorkordersService, StatusesTokens} from "../workorders/workorders.service";

import { DashboardService} from "./dashboard.service";
import {TimeInUnitsPipe} from "../../shared/pipes/time-in-units.pipe"

import * as moment from 'moment';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    providers: [DashboardService]
})
export class DashboardComponent implements OnInit {

    inProgress=false;
    //change status on Next pending wo
    nextStatus=0;
    //change status on last finished wo
    nextLastFinished=0;
    @ViewChild(BaseChartDirective) chart: BaseChartDirective;

    private workOrdersSummary = {
        pending: 0,
        in_progress: 0,
        finished: 0,
        total: 0
    };

    private mapValue = {
        lat: 41,
        long: -1,
        zoom: 7
    };    

    private nextWorkorders=[];
    
    private finishedWorkorders = [];

    private workordersNotStarted = [
        {location: {lat: 41, long:-1}}
    ];
    private workordersInProgress = [
        {location: {lat: 41, long:-1}},
        
    ];
    private workordersPaused = [
        {location: {lat: 41, long:-2}},        
    ];
    private workordersFinished = [
        {location: {lat: 40, long:-3}},        
    ];

    private graphLabels = [];
    private graphData = [];
    private graphFlag = 0;

    constructor(
        private workordersService: WorkordersService,
        private translate: TranslateService,
        private dashboardService: DashboardService,
        private router: Router
    ) { }

    ngOnInit() {        

        this.dashboardService.getSummary().toPromise().then(summaryInfo=>{
            this.workOrdersSummary=summaryInfo;           
        })        

        this.dashboardService.getWorkorder().toPromise().then(workorderInfo=>{ 
            this.nextWorkorders=workorderInfo.nextWorkorders;            
            this.finishedWorkorders=workorderInfo.finishedWorkorders;
        })
        
        this.dashboardService.getLocation().toPromise().then(
            
            locationInfo=>{                       
                this.workordersNotStarted=locationInfo.not_started;
                this.workordersInProgress=locationInfo.in_progress;
                this.workordersPaused=locationInfo.paused;
                this.workordersFinished=locationInfo.finished;                                          
            }
        ) 
        this.dashboardService.getDeficiencies(this.translate.currentLang.substring(0,2)).toPromise().then(deficienciesInfo => {
           
            //ng2-tables has a bug and labels should be added this way
            this.graphLabels.length = 0;
            this.graphLabels.push(...deficienciesInfo.parts);
            
            this.graphData.length = 0;
            this.graphData.push(...deficienciesInfo.deficiencies);
            

            // Modify the flag to notify the component, cause of a bug in ChartJS
            this.graphFlag++;
            }
        )  
    }

    private getDeficienciesClass(value) {
        return value === 0 ? 'deficiencies-tag ok' : 'deficiencies-tag nok';
    }

    getWorkOrderMainContractor(wo) {
        return wo.company;
    }

    getWorkOrderActivity(wo) {
        return wo.activity;
    }

    public detailsWorkorder($event, id) {
        this.router.navigate(['/admin/workorders', id]);
    }
    
    private getStatusClass(status) {
        return this.workordersService.getStatusClass(status);
    }

    private getStatusName(statusCode) {
        return StatusesTokens[statusCode];
    }

    private getTimeDiff(date) {
        if (!date) {
            return '-'
        };
        var diff = moment().diff(date, 'seconds').toString();
        return new TimeInUnitsPipe().transform(diff);
    }
}



// WEBPACK FOOTER //
// ./src/app/routes/dashboard/dashboard.component.ts